import React, { useState } from "react";
import { LSDBCoreTable } from "../../../common/LSDBCoreTable";
import { generalFilter, useDefaultColumn } from "../../../../util/filter";
import { TechWriterDate } from "./TechWriterDate";
import { ReportNotes } from "./ReportNotes";
import { NoteViewer } from "./NoteViewer";
import { Link, useHistory } from "react-router-dom";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Icon,
  IconButton,
  Link as MuiLink,
  Paper,
  Radio,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  useTheme,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import { useProjectNotes } from "../../projectQueries";
import {
  Column,
  useFilters,
  useGlobalFilter,
  useSortBy,
  useTable,
} from "react-table";
import { useReportNotes } from "../../../common/CommonMutations";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import MuiTable from "@material-ui/core/Table";
import { EditWriter } from "./EditWriter";
import { useAuthContext } from "../../../common/AuthContext";
import { useWriterToApprover } from "../../../common/CommonQueries";
import { NotesProjects } from "./NotesProjects";
import { toast } from "react-toastify";
import { useFetchContext } from "../../../common/FetchContext";
import { WriterFileUpload } from "./WriterFileUpload";
import ScreenWidth from "../../../common/ScreenWidth";
import { CheckList } from "./CheckList";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import { WriterDownloadDialog } from "./WriterDownloadDialog";
import { WriterDownloadDialogWrapper } from "./ReportProjectContext";
import { BomDetailsDialog } from "./BomDetailsDialog";
import { ProjectDownloadDialog } from "./ProjectDownloadDialog";
import TipTap from "./TipTap/TipTap";
import {
  useContinueReportWriting,
  useCreateReport,
  useReportIntakeImages,
} from "../../projectManagementQueries";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

export const ReportWriterTable = ({ data, refetch }: any) => {
  const { authAxios } = useFetchContext();

  const defaultColumn = useDefaultColumn();
  const theme = useTheme();
  const widthCurrent = ScreenWidth();
  const { state } = useAuthContext();
  const history = useHistory();
  const { mutateAsync: mutate, isLoading: isLoadingMoveToApprover } =
    useWriterToApprover();
  const [rowLoading, setRowLoading] = React.useState<{
    [key: string]: boolean;
  }>({});
  const [selectedRowId, setSelectedRowId] = useState<string | null>(null);

  const [selected, setSelected] = useState(1);
  const [loading, setLoading] = React.useState(false);

  const templates = [
    {
      id: 14,
      title: "Intake report — INTV11.2.1",
      description:
        "Pre-light soaking characterization · Datasheet specs · STC performance data · EL images · Visual inspection · Wet leakage",
      chips: [
        "Customer",
        "Project #",
        "Manufacturer",
        "Module Type",
        "Serial#01-30",
      ],
    },
    {
      id: 2,
      title: "LID report — LIDV11.2.1",
      description:
        "Light induced degradation · Pre/post light soak STC data · LIC performance · EL images",
      chips: ["Customer", "Module Type", "Serial#01-17", "BOM #"],
    },
    {
      id: 3,
      title: "BDS report — BDSV11.2.1",
      description:
        "Backsheet durability sequence · Color measurements · Visual inspection",
      chips: ["Customer", "BDS Serial", "Module Type"],
    },
  ];

  const [selectedReportData, setSelectedReportData] = useState<{
    id: any;
    work_order_id: any;
  } | null>(null);

  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenTipTap = (report: any) => {
    setSelectedReport(report);
    setOpenTipTap(true);
  };

  const handleOpenDialog = (id: any, work_order_id: any) => {
    setSelectedReportData({ id, work_order_id });
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const [openChecklist, setOpenChecklist] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [openTipTap, setOpenTipTap] = useState(false);
  const [selectedReport, setSelectedReport] = useState<any>(null);
  const [selectedReportWriting, setSelectedReportWriting] = useState<any>(null);
  // This tracks which specific report is currently being created/loaded
  const [actionLoading, setActionLoading] = useState<{
    [key: string]: boolean;
  }>({});

  const { mutateAsync: createReport } = useCreateReport();
  const { mutateAsync: continueReport } = useContinueReportWriting();

  const handleCloseTipTap = () => {
    setOpenTipTap(false);
  };

  const handleCloseChecklist = () => {
    setOpenChecklist(false);
  };

  const handleCreateReport = (report: any) => {
    history.push(`/reports/report_writers_agenda/tiptap/${report.id}?mode=new`, {
      apiUrl: report.url_param
    });
  };

  const handleContinueReport = (report: any) => {
    history.push(
      `/reports/report_writers_agenda/tiptap/${report.id}?mode=continue`,
    );
  };

  const columns: any[] = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        filter: generalFilter,
      },

      {
        id: "Report Type",
        accessor: "report_type_definition_name",

        filter: generalFilter,
        width: 250,
        minWidth: 200,
        maxWidth: 300,
        align: "center",
      },
      {
        id: "Project Number",
        accessor: "project_number",

        filter: generalFilter,
        width: 250,
        minWidth: 250,
        maxWidth: 300,
        align: "center",
        Cell: ({ cell, row }: any) => {
          const [open, setOpen] = React.useState(false);

          return (
            <>
              <div>
                <MuiLink
                  style={{ cursor: "pointer" }}
                  onClick={() => setOpen(true)}
                >
                  {row.original.project_number}
                </MuiLink>
              </div>
              {open && (
                // <WriterDownloadDialogWrapper open={open} handleclose={() => setOpen(false)} projectnumber={row.original.project_number} />
                <ProjectDownloadDialog
                  open={open}
                  handleclose={() => setOpen(false)}
                  projectnumber={row.original.project_number}
                />
              )}
            </>
          );
        },
      },

      {
        id: "Customer",
        accessor: "customer_name",

        filter: generalFilter,
        width: 250,
        minWidth: 200,
        maxWidth: 300,
        align: "center",
        Cell: ({ value }: any) => <>{value ? value : "N/A"}</>,
      },

      {
        id: "PM",
        accessor: "project_manager_name",

        filter: generalFilter,
        width: 250,
        minWidth: 200,
        maxWidth: 300,
        align: "center",
        Cell: ({ value }: any) => <>{value ? value : "N/A"}</>,
      },
      {
        id: "NTP",
        accessor: "ntp_date",

        filter: generalFilter,
        width: 250,
        minWidth: 200,
        maxWidth: 300,
        align: "center",
        Cell: ({ value }: any) => (
          <>{value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : "N/A"}</>
        ),
      },
      {
        id: "BOM Type",
        accessor: "bom",

        filter: generalFilter,
        width: 250,
        minWidth: 200,
        maxWidth: 300,
        align: "center",
        // Cell: ({ value }: any) => <><MuiLink style={{ cursor: "pointer" }}>{value ? value : "N/A"}</MuiLink></>
        Cell: ({ cell, row, value }: any) => {
          const [open, setOpen] = React.useState(false);

          return (
            <>
              <div>
                <MuiLink
                  style={{ cursor: "pointer" }}
                  onClick={() => setOpen(true)}
                >
                  {value}
                </MuiLink>
              </div>
              {open && (
                <BomDetailsDialog
                  open={open}
                  handleclose={() => setOpen(false)}
                  projectnumber={row.original.project_number}
                  workOrderId={row.original.work_order}
                  bomname={row.original.bom}
                  customer={row.original.customer_name}
                />
              )}
            </>
          );
        },
      },

      {
        id: "Priority",
        accessor: "priority",

        filter: generalFilter,
        width: 250,
        minWidth: 200,
        maxWidth: 300,
        align: "center",
        Cell: ({ value }: any) => <>{value ? value : "N/A"}</>,
      },
      {
        id: "Contractually Obligated Date",
        accessor: "contractually_obligated_date",

        filter: generalFilter,
        width: 250,
        minWidth: 250,
        maxWidth: 300,
        align: "center",
        Cell: ({ value }: any) => (
          <>{value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : "N/A"}</>
        ),
      },
      {
        id: "Data Verification Date",
        accessor: "data_verification_date",

        filter: generalFilter,
        width: 250,
        minWidth: 250,
        maxWidth: 300,
        align: "center",
        Cell: ({ value }: any) => (
          <>{value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : "N/A"}</>
        ),
      },
      {
        id: "PQP Version",
        accessor: "pqp_version",

        filter: generalFilter,
        width: 250,
        minWidth: 200,
        maxWidth: 300,
        align: "center",
        Cell: ({ value }: any) => <>{value ? value : "N/A"}</>,
      },
      {
        id: "Tech Writer Start Date",
        accessor: "tech_writer_startdate",
        filter: generalFilter,
        width: 250,
        minWidth: 250,
        maxWidth: 300,
        align: "center",

        Cell: ({ row }: any) => {
          const { tech_writer_startdate, id, work_order, report_writer_name } =
            row.original;

          return !tech_writer_startdate ? (
            <TechWriterDate
              name="Tech_Writer_start_Date"
              report_id={id}
              workorder_id={work_order}
              refetch={refetch}
              disabled={!report_writer_name}
              writer_name={report_writer_name}
            />
          ) : (
            <span>
              {moment(tech_writer_startdate).format("YYYY-MM-DD HH:mm:ss")}
            </span>
          );
        },
      },
      {
        id: "Report Writer Name",
        accessor: "report_writer_name",

        filter: generalFilter,
        width: 250,
        minWidth: 200,
        maxWidth: 300,
        align: "center",
        Cell: ({ row, value }: any) => {
          const { report_writer_name } = row.original;
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {value ? value : "N/A"}

              {state.user === "Jennifer.Bravo@pvel.com" ||
                state.user === "max.macpherson@pvel.com" ||
                state.user === "nagi@pvel.com" ? (
                <EditWriter
                  id={row.original.id}
                  name={"report_writer_name"}
                  refetch={refetch}
                />
              ) : null}
            </div>
          );
        },
      },
      {
        id: "Report Reviewer Assigned To",
        accessor: "report_reviewer_name",

        filter: generalFilter,
        width: 250,
        minWidth: 200,
        maxWidth: 300,
        align: "center",
        Cell: ({ row, value }: any) => {
          const { report_reviewer_name } = row.original;
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {value ? value : "N/A"}

              {state.user === "Jennifer.Bravo@pvel.com" ||
                state.user === "max.macpherson@pvel.com" ||
                state.user === "nagi@pvel.com" ? (
                <EditWriter
                  id={row.original.id}
                  name={"report_reviewer_name"}
                  refetch={refetch}
                />
              ) : null}
            </div>
          );
        },
      },

      {
        id: "Link to Finished Report for Review",
        accessor: "report_file",
        filter: generalFilter,
        width: 250,
        minWidth: 280,
        maxWidth: 300,
        align: "center",
        Cell: ({ row }: any) => {
          const { id, work_order } = row.original;
          return (
            <MuiLink
              component="button"
              variant="body1"
              color="primary"
              onClick={() => handleOpenDialog(id, work_order)}
            >
              View Report
            </MuiLink>
          );
        },
      },

      {
        id: "Draft Moved to Approval Queue",
        accessor: "Draft_to_Approval",
        filter: generalFilter,
        width: 250,
        minWidth: 280,
        maxWidth: 300,
        align: "center",
        Cell: ({ row }: any) => {
          const {
            id,
            tech_writer_startdate,
            report_writer_name,
            report_reviewer_name,
            ntp_date,
            is_writer,
            is_reviewer,
          } = row.original;
          const isLoading = rowLoading[id] || false;
          const [openDialog, setOpenDialog] = useState(false);
          const handleClose = () => {
            setOpenDialog(false);
          };
          const handleOpenDialog = () => {
            setOpenDialog(true);
          };
          // const isEnabled =
          //     !tech_writer_startdate &&
          //     !report_writer_name &&
          //     !report_reviewer_name &&
          //     !isLoading;
          const isEnabled =
            !report_writer_name || !report_reviewer_name || isLoading;

          const handleMoveToApprover = async () => {
            if (!ntp_date) {
              toast.warn(
                "NTP Date is missing. Please assign the NTP Date in the workorder.",
              );
              return;
            } else if (!tech_writer_startdate) {
              toast.warn(
                "Tech Writer Start  Date is missing. Please fill the tech writer start date.",
              );
              return;
            } else {
              setRowLoading((prev) => ({ ...prev, [id]: true }));
              try {
                await mutate({
                  report_result_id: id,
                  authAxios,
                });

                toast.success("Report is moved to Approver!");
                handleClose();
                await refetch();
              } catch (error: any) {
                console.error(error);
                toast.error("Error while Moving to approver!");
              } finally {
                setRowLoading((prev) => ({ ...prev, [id]: false }));
              }
            }
          };

          return (
            <>
              <Button
                variant="contained"
                color="primary"
                style={{
                  width: "150px",
                  fontSize: "10px",
                  paddingTop: "15px",
                  paddingBottom: "15px",
                }}
                onClick={handleOpenDialog}
                disabled={isEnabled}
              >
                Move To Approver
              </Button>
              {is_reviewer ? (
                <Dialog open={openDialog} onClose={handleClose} maxWidth="md">
                  <DialogTitle>Send Report for Approval</DialogTitle>
                  <DialogContent>
                    Are you sure you want to Move the Report to the Approver?
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose} style={{ marginTop: "20px" }}>
                      Cancel
                    </Button>
                    <Button
                      onClick={handleMoveToApprover}
                      color="primary"
                      variant="contained"
                      style={{ marginTop: "20px" }}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        "Confirm"
                      )}
                    </Button>
                  </DialogActions>
                </Dialog>
              ) : (
                <Dialog open={openDialog} onClose={handleClose}>
                  <DialogTitle>Access Denied</DialogTitle>
                  <DialogContent>
                    <Typography>
                      You are not authorized to approve this report. Please
                      contact an approver.
                    </Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={handleClose}
                      variant="contained"
                      color="primary"
                    >
                      Close
                    </Button>
                  </DialogActions>
                </Dialog>
              )}
            </>
          );
        },
      },

      {
        id: "Check_List",
        Header: "Check List",
        disableFilters: true,
        Cell: ({ row }: any) => {
          const {
            id,
            is_checklist,
            is_writer,
            is_superuser,
            tech_writer_startdate,
          } = row.original;
          const [open, setOpen] = React.useState(false);

          const isDisabled = !tech_writer_startdate;

          return (
            <>
              <IconButton
                style={{
                  color: isDisabled ? "grey" : is_checklist ? "green" : "red",
                }}
                size="small"
                onClick={() => {
                  if (!isDisabled) setOpen(true);
                }}
                disabled={isDisabled}
              >
                {is_checklist ? (
                  <PlaylistAddCheckIcon fontSize="large" />
                ) : (
                  <PlaylistAddIcon fontSize="large" />
                )}
              </IconButton>

              {open && (
                <CheckList
                  id={id}
                  refetch={refetch}
                  open={open}
                  onClose={() => setOpen(false)}
                  is_writer={is_writer}
                  is_superuser={is_superuser}
                />
              )}
            </>
          );
        },
      },

      {
        id: "notes",
        Header: "Notes",
        align: "center",
        disableFilters: true,
        Cell: ({ row }: any) => {
          const { id, url } = row.original;

          return (
            <ReportNotes
              id={id}
              url={url}
              type={1}
              model={"report"}
              invalidate={[
                "my_reports",
                ["reportNotes", row.values.id],
                "report_Writer",
              ]}
              getNotes={useReportNotes}
            />
          );
        },
      },
      {
        id: "project_notes",
        Header: "ProjectsNotes",
        align: "center",
        disableFilters: true,
        Cell: ({ row }: any) => {
          const { id, url, project_id } = row.original;

          return (
            <>
              <NotesProjects id={project_id} type={1} />
            </>
          );
        },
      },
      {
        id: "add_tasks",
        Header: "AddTasks",
        align: "center",
        disableFilters: true,
        Cell: ({ row }: any) => {
          const { id, url } = row.original;
          return (
            <NoteViewer
              id={id}
              url={url}
              type={1}
              model={"report"}
              invalidate={[
                "my_reports",
                ["reportNotes", row.values.id],
                "report_Writer",
              ]}
              getNotes={useReportNotes}
            />
          );
        },
      },

      {
        id: "report_status",
        Header: "Report status",
        align: "center",
        disableFilters: true,
        Cell: ({ row }: any) => {
          const { report_status } = row.original;
          // Expected values:
          // "not_started", "writing", "in_review", "approved"

          let label = "Not started";
          let report_status_label = report_status;
          let bgColor = "#F3F1ED";
          let textColor = "#8A8A8A";
          let dotColor = "#8A8A8A";

          switch (report_status_label) {
            case "draft":
              label = "Writing";
              bgColor = "#EEF4FF";
              textColor = "#2563EB";
              dotColor = "#2563EB";
              break;

            case "saved as version":
              label = "Writing";
              bgColor = "#EEF4FF";
              textColor = "#2563EB";
              dotColor = "#2563EB";
              break;

            case "in_review":
              label = "In review";
              bgColor = "#FFF5D9";
              textColor = "#D97706";
              dotColor = "#F59E0B";
              break;

            case "approved":
              label = "Approved";
              bgColor = "#E8F7EE";
              textColor = "#15803D";
              dotColor = "#16A34A";
              break;

            default:
              label = "Not started";
              bgColor = "#F3F1ED";
              textColor = "#8A8A8A";
              dotColor = "#8A8A8A";
          }

          return (
            <Chip
              size="small"
              label={
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "11px",
                    fontWeight: 500,
                  }}
                >
                  <span
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      background: dotColor,
                      display: "inline-block",
                      marginRight: 6,
                    }}
                  />
                  {label}
                </span>
              }
              style={{
                backgroundColor: bgColor,
                color: textColor,
                borderRadius: "20px",
                height: "20px",
                padding: "0 6px",
                display: "inline-flex",
                alignItems: "center",
              }}
            />
          );
        },
      },
      {
        id: "report",
        Header: "Report",
        align: "center",
        disableFilters: true,

        Cell: ({ row }: any) => {
          const {
            id,
            report_status = "not_started",
            report_version,
            report_name,
            is_new_report,
            project_number,
          } = row.original;

          // Check if THIS specific row is loading
          const isButtonLoading = actionLoading[id] || false;

          if (is_new_report === true) {
            return (
              <>
                <Button
                  variant="outlined"
                  // Swap icon for a spinner when loading
                  startIcon={
                    isButtonLoading ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : (
                      <EditOutlinedIcon style={{ fontSize: 16 }} />
                    )
                  }
                  onClick={() => handleCreateReport(row.original)}
                  disabled={isButtonLoading} // Disable button while loading
                  style={{
                    minWidth: 80,
                    height: 25,
                    width: 120,
                    border: "1px solid #0F766E",
                    borderRadius: 8,
                    background: "#e7f3f2",
                    color: "#0F766E",
                    textTransform: "none",
                    fontSize: 12,
                    fontWeight: 500,
                    boxShadow: "none",
                  }}
                >
                  {isButtonLoading ? "Creating..." : "Write report"}
                </Button>
                {report_version !== null && (
                  <Typography variant="caption">
                    {`${report_version}`}
                  </Typography>
                )}
              </>
            );
          }

          if (is_new_report === false) {
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <Button
                  variant="outlined"
                  // Swap icon for a spinner when loading
                  startIcon={
                    isButtonLoading ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : (
                      <EditOutlinedIcon style={{ fontSize: 16 }} />
                    )
                  }
                  onClick={() => handleContinueReport(row.original)}
                  disabled={isButtonLoading} // Disable button while loading
                  style={{
                    minWidth: 80,
                    height: 25,
                    width: 140,
                    border: "1px solid #2420e3",
                    borderRadius: 8,
                    background: "#eeeef8",
                    color: "#2420e3",
                    textTransform: "none",
                    fontSize: 12,
                    fontWeight: 500,
                  }}
                >
                  {isButtonLoading ? "Loading..." : "Continue editing"}
                </Button>

                {report_version && (
                  <Typography variant="caption">{report_version}</Typography>
                )}
              </div>
            );
          }
        },
      },
    ],
    [actionLoading, rowLoading, state.user, refetch],
  );
  const { getTableProps, visibleColumns, headerGroups, rows, prepareRow } =
    useTable(
      {
        data: data,
        columns,
        defaultColumn,
        initialState: {
          hiddenColumns: ["id"],
        },
      },
      useFilters,
      useGlobalFilter,
      useSortBy,
    );

  return (
    <>
      <TableContainer
        data-testid="tableContainer"
        style={{
          ...theme.tableContainer,
          maxHeight: "500px",
          overflowX: "auto",
          overflowY: "auto",
          whiteSpace: "nowrap",
          maxWidth: `${widthCurrent}px`,
        }}
        component={Paper}
      >
        <MuiTable stickyHeader {...getTableProps()} size="small">
          <TableHead>
            {headerGroups.map((headerGroup) => (
              <TableRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <TableCell
                    style={{
                      // ...theme.noLeftRightPadding,
                      width: column.width,
                      minWidth: column.minWidth,
                      maxWidth: column.maxWidth,
                      textAlign: "center",
                    }}
                  >
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      spacing={0}
                    >
                      <Grid item xs={12} {...column.getHeaderProps()}>
                        <Grid
                          container
                          direction="row"
                          alignItems="center"
                          spacing={0}
                        >
                          <Typography
                            variant="subtitle2"
                            style={{
                              textAlign: "center",
                              width: "100%",
                              verticalAlign: "middle",
                            }}
                          >
                            {column.render("Header")}
                          </Typography>
                          {column.canFilter ? column.render("Filter") : null}

                          <Grid item xs={2}>
                            {![
                              "notes",
                              "add_tasks",
                              "project_notes",
                              "Check_List",
                              "report",
                              "report_status",
                            ].includes(column.id) && (
                                <IconButton
                                  type="submit"
                                  aria-label="search"
                                  size="small"
                                  {...column.getSortByToggleProps()}
                                >
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <ArrowDropDownIcon />
                                    ) : (
                                      <ArrowDropUpIcon />
                                    )
                                  ) : (
                                    <CallSplitIcon />
                                  )}
                                </IconButton>
                              )}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableHead>
          <TableBody>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <>
                  <TableRow {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <TableCell
                          {...cell.getCellProps()}
                          style={{
                            width: cell.column.width,
                            minWidth: cell.column.minWidth,
                            maxWidth: cell.column.maxWidth,
                          }}
                        >
                          {cell.render("Cell")}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </>
              );
            })}
          </TableBody>
        </MuiTable>
      </TableContainer>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Report Template</DialogTitle>
        <DialogContent>
          {selectedReportData && (
            <WriterFileUpload
              id={selectedReportData.id}
              work_order_id={selectedReportData.work_order_id}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openTipTap}
        onClose={handleCloseTipTap}
        fullWidth
        maxWidth="md"
        PaperProps={{
          style: {
            borderRadius: 14,
            height: "88vh",
            overflow: "hidden",
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          style={{
            padding: "22px 26px",
          }}
        >
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6">
              Select a template for Module Intake
            </Typography>
            <IconButton onClick={handleCloseTipTap}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </DialogTitle>

        <Divider />

        {/* Scroll Area */}
        <DialogContent
          style={{
            padding: 24,
            overflowY: "auto",
            background: "#fff",
          }}
        >
          <Typography
            style={{
              color: "#757575",
              marginBottom: 24,
              lineHeight: 1.5,
            }}
          >
            Choose a template to start writing. The document will be
            pre-populated with project data from the LSDB.
          </Typography>

          <Typography
            style={{
              fontWeight: 600,
              color: "#8c8c8c",
              letterSpacing: 0.5,
              textTransform: "uppercase",
              marginBottom: 18,
            }}
          >
            PVEL 2025 Templates (V11)
          </Typography>

          {templates.map((item) => {
            const active = selected === item.id;

            return (
              <Paper
                key={item.id}
                elevation={0}
                onClick={() => setSelected(item.id)}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  cursor: "pointer",
                  padding: "18px 20px",
                  marginBottom: 14,
                  borderRadius: 8,
                  border: active ? "1px solid #0f7b6c" : "1px solid #E5E7EB",
                  background: active ? "#EDF8F6" : "#fff",
                  transition: "all .2s ease",
                }}
              >
                <Radio
                  checked={active}
                  style={{
                    padding: 0,
                    marginTop: 2,
                    marginRight: 16,
                    color: "#0f7b6c",
                  }}
                />

                <Box flex={1}>
                  <Typography
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "#2E2E2E",
                      marginBottom: 4,
                      lineHeight: 1.3,
                    }}
                  >
                    {item.title}
                  </Typography>

                  <Typography
                    style={{
                      fontSize: 12,
                      color: "#7A7A7A",
                      lineHeight: 1.45,
                      marginBottom: 12,
                    }}
                  >
                    {item.description}
                  </Typography>

                  <Box display="flex" flexWrap="wrap" style={{ gap: 8 }}>
                    {item.chips.map((chip) => (
                      <Chip
                        key={chip}
                        label={chip}
                        size="small"
                        variant="outlined"
                        style={{
                          height: 22,
                          borderRadius: 4,
                          background: "#FAFAFA",
                          border: "1px solid #E0E0E0",
                          fontSize: 12,
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              </Paper>
            );
          })}
        </DialogContent>

        <Divider />

        {/* Footer */}
        <DialogActions
          style={{
            padding: "18px 24px",
            justifyContent: "flex-end",
            background: "#fff",
          }}
        >
          <Button
            onClick={handleCloseTipTap}
            style={{
              marginRight: 10,
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            style={{
              background: "#0B8C7B",
              color: "#fff",
              padding: "8px 20px",
              borderRadius: 6,
              fontSize: 14,
              textTransform: "none",
            }}
            onClick={handleCreateReport}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Create report"
            )}
          </Button>

          {/* <Button
            variant="contained"
            style={{
              background: "#0B8C7B",
              color: "#fff",
              padding: "8px 20px",
              borderRadius: 6,
              fontSize:14,
              textTransform:"none"
            }}
            onClick={() => {
              handleCloseTipTap();
              history.push("/reports/report_writers_agenda/tiptap");
            }}
          >
            Create report
          </Button> */}
        </DialogActions>
      </Dialog>
    </>
  );
};
